import React, {useState} from 'react';
import { Box } from '../../../../styled';
import {Spinner} from 'react-bootstrap';
import HighlightMarker from '../../../../components/HighlightMarker/HighlightMarker';

const Preview = ({ item }:any) => {
  const [messagePreview, setMessagePreview] = useState(item.fullMessage);

  if (!item.fullMessage) {
    const timeout = setTimeout(() => {
      item.resultMessage();
      setMessagePreview(item.fullMessage);
      clearTimeout(timeout);
    }, 200);
  }

  return (
    <>
      {messagePreview ? (
        <HighlightMarker>
          {messagePreview}
        </HighlightMarker>
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          paddingTop={40}
          paddingBottom={40}
        >
          <Spinner animation="border" style={{ color: '#1C62EF' }} />
        </Box>
      )}

    </>
  )
}

export default Preview;